import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../Components/Common/BreadCrumbs";
import CoopUserService from "../../services/CoopUserService/CoopUserService";

const UserDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "Users", link: "/users" },
    { title: "User Detail" },
  ];

  const fetchData = async () => {
    try {
      const fetchedData = await CoopUserService.getById(id);
      setData(fetchedData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container fluid className="mt-5">
      <div className="page-content">
        <Breadcrumbs items={breadcrumbItems} />
        <Row className="justify-content-center">
          <Col xs={5}>
            <Row className="mb-5">
              <Col xs={12} className="text-end">
                <h2
                  className="cursor-pointer"
                  onClick={() => {
                    navigate("/user-management");
                  }}
                >
                  <i className="bx bx-x"></i>
                </h2>
              </Col>
              <Col xs={12} className="text-center">
                <h4 className="card-title mb-0">User Details</h4>
              </Col>
            </Row>
            <Card style={{ borderRadius: "20px", backgroundColor: "#f9f9ff" }}>
              <CardBody>
                <Col xs={12} className="text-center">
                  <Row className="mt-4 bg-light py-2">
                    <Col xs={12} className="text-start">
                      <span className="fw-bold px-3">User Information</span>
                    </Col>
                  </Row>

                  <Row className="mt-4 ps-4">
                    <Row>
                      <Col
                        xs={12}
                        className="text-center py-2 bg-light mb-1 text-muted"
                      >
                        <Row>
                          <Col xs={12} className="text-center">
                            <img
                              src={`data:image/png;base64,${data.image}`}
                              alt="profile"
                              className="rounded-circle"
                              width="100"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} className="text-center">
                            Profile Picture
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Username
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.userName}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        First Name
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.firstName}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Last Name
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.lastName}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Address
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.address}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Email Address
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.email}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Phone Number
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.phone}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Role
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.roles && data.roles.length > 0
                          ? data.roles[0].name
                          : "N/A"}{" "}
                      </Col>
                    </Row>
                  </Row>
                </Col>
              </CardBody>

              <Row>
                <Col lg={4}></Col>
                <Col lg={4} className="text-end mb-3">
                  <Button
                    className="w-100 bg-warning border-white"
                    onClick={() => {
                      navigate("/user-management");
                    }}
                  >
                    Back
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default UserDetail;
